var _a, _b, _c, _d, _e;
// import { ChainId, NATIVE_ADDRESS, WRAPPED_SOL } from './networks';
// import { fetchEVMTokenBalances } from '../evm/base/fetchEVMTokenBalance';
// import { fetchSVMTokenBalances } from '../solana/base/fetchSVMTokenBalances';
export var TIME_PERIOD;
(function (TIME_PERIOD) {
    TIME_PERIOD[TIME_PERIOD["ONE_YEAR"] = 31536000] = "ONE_YEAR";
    TIME_PERIOD[TIME_PERIOD["ONE_DAY"] = 86400] = "ONE_DAY";
    TIME_PERIOD[TIME_PERIOD["FIVE_MINUTES"] = 300] = "FIVE_MINUTES";
    TIME_PERIOD[TIME_PERIOD["TEN_MINUTES"] = 600] = "TEN_MINUTES";
    TIME_PERIOD[TIME_PERIOD["TWO_MINUTES"] = 120] = "TWO_MINUTES";
    TIME_PERIOD[TIME_PERIOD["ONE_MINUTE"] = 60] = "ONE_MINUTE";
    TIME_PERIOD[TIME_PERIOD["ONE_HOUR"] = 3600] = "ONE_HOUR";
    TIME_PERIOD[TIME_PERIOD["THIRTY_SECONDS"] = 30] = "THIRTY_SECONDS";
})(TIME_PERIOD || (TIME_PERIOD = {}));
export const OKX_API_KEY = process.env.OKX_API_KEY;
export const OKX_PASSPHRASE = process.env.OKX_PASSPHRASE;
export const OKX_PROJECT_ID = process.env.OKX_PROJECT_ID;
export const OKX_SECRET_KEY = process.env.OKX_SECRET_KEY;
export const ODOS_REFERRAL_CODE = process.env.ODOS_REFERRAL_CODE;
export const DEBRIDGE_ACCESS_TOKEN = process.env.DEBRIDGE_ACCESS_TOKEN;
export const SQUIDROUTER_ID = process.env.SQUIDROUTER_ID;
export const DEV_PKPS = ['0xFB183284f7b90aE2AfbD53b3C6Ff76c85F2cC0B7'];
export const ENVIRONMENT = (process.env.ENV ||
    process.env.NEXT_PUBLIC_ENV);
export const ENV_LIT_NETWORK = (process.env
    .NEXT_PUBLIC_LIT_NETWORK || process.env.LIT_NETWORK);
export const LIT_RPC_URL = process.env.LIT_RPC_URL || process.env.NEXT_PUBLIC_LIT_RPC_URL;
export const LIT_RATE_LIMIT_NFT_CONTRACT = (overrideNetwork) => {
    const networkToUse = overrideNetwork || ENV_LIT_NETWORK;
    return networkToUse == 'datil-dev'
        ? '0x1A12D5B3D6A52B3bDe0468900795D35ce994ac2b'
        : networkToUse == 'datil-test'
            ? '0xa17f11B7f828EEc97926E56D98D5AB63A0231b77'
            : networkToUse == 'datil'
                ? '0x01205d94Fee4d9F59A4aB24bf80D11d4DdAf6Eed'
                : '';
};
export const LOCAL_BASE = 'http://localhost';
export const DEV_BASE = 'https://dev-api.tradegenius.com';
export const STAGING_BASE = 'https://staging-api.tradegenius.com';
export const PROD_BASE = 'https://api.tradegenius.com';
export function getUrls(envOverride) {
    const env = envOverride || ENVIRONMENT;
    if (env === 'LOCAL') {
        return {
            EXECUTOR_URL: LOCAL_BASE + ':3101',
            QUOTER_URL: LOCAL_BASE + ':3102/quoting',
            INDEXER_URL: STAGING_BASE + '/indexer',
            //'http://localhost:3105/indexer'
        };
    }
    if (env === 'DEV') {
        return {
            EXECUTOR_URL: DEV_BASE,
            QUOTER_URL: DEV_BASE + '/quoting',
            INDEXER_URL: STAGING_BASE + '/indexer',
        };
    }
    if (env === 'STAGING') {
        return {
            EXECUTOR_URL: STAGING_BASE,
            QUOTER_URL: STAGING_BASE + '/quoting',
            INDEXER_URL: STAGING_BASE + '/indexer',
        };
    }
    if (env === 'PROD') {
        return {
            EXECUTOR_URL: PROD_BASE,
            QUOTER_URL: PROD_BASE + '/quoting',
            INDEXER_URL: STAGING_BASE + '/indexer',
        };
    }
    return {
        EXECUTOR_URL: '',
        QUOTER_URL: '',
        INDEXER_URL: '',
    };
}
export const CURRENT_VERSION = process.env.CURRENT_VERSION;
export async function getControllerPrivateKey(orchestratorPKP) {
    const orchestratorIndex = ORCHESTRATORS({ excludeFeeCollector: false }).findIndex((o) => o.ethAddress === orchestratorPKP.ethAddress);
    const envName = `ORCHESTRATOR_${orchestratorIndex}_CONTROLLER_PRIVATE_KEY`;
    const prefix = process.env.LIT_NETWORK == 'datil-dev' ? 'DATIL_DEV_' : 'DATIL_TEST_';
    const envPath = `${prefix}${envName}`;
    const GENIUS_DEV_WALLET_PRIVATE_KEY = process.env[envPath];
    return GENIUS_DEV_WALLET_PRIVATE_KEY;
}
export function getDevWallets() {
    return {
        GENIUS_DEV_WALLET: process.env.GENIUS_DEV_WALLET_ADDRESS,
        GENIUS_DEV_WALLET_PRIVATE_KEY: process.env.GENIUS_DEV_WALLET_PRIVATE_KEY,
    };
}
export const ORCHESTRATORS = ({ orchestratorOverride, excludeFeeCollector = true, }) => {
    const LIT_NETWORK_IN_USE = orchestratorOverride
        ? orchestratorOverride
        : (process.env.LIT_NETWORK || process.env.NEXT_PUBLIC_LIT_NETWORK);
    if (LIT_NETWORK_IN_USE === 'datil-dev') {
        return excludeFeeCollector ? DATIL_DEV_ORCHESTRATORS.slice(1) : DATIL_DEV_ORCHESTRATORS;
    }
    else if (LIT_NETWORK_IN_USE === 'datil') {
        return excludeFeeCollector
            ? DATIL_MAINNET_STAGING_ORCHESTRATORS.slice(1)
            : DATIL_MAINNET_STAGING_ORCHESTRATORS;
    }
};
const DATIL_DEV_ORCHESTRATORS = [
    //First is fee collector
    {
        hexTokenId: '0x851d6f495fabde01cfae20091edcbc3d23f752e81d43527af4c68c52bea46f91',
        tokenId: '60209615498448973033740783833547297483970240169033645919960513423105155428241',
        publicKey: '0x04bed79c975b616c7216a772054d370b8479f7fdbe096a2627bf306451ae6446cb308884174e9b7e0e2b40740fc148c8031fcfe70151e2b6dca01814372e38ed6b',
        // ethAddress: '0xcb1178A50a01147949c883432aee904Eb7788015',
        //replacing with the below address for fee collection that we have keys for
        ethAddress: '0x34dac76555Ab52fAB3Eb7071fB864Dbb8FA3752d',
        ciphertext: 'pCIxj/zz4Lg726HS8foO4qxqWxVYFnetwbg/VJHPL+YjicLWocZIVa87gBZWTLCwDTQ0QAxlWEQJCFTTigKEjjFRT7cZXqi6nHNqNTIrr/3lAVoq/0jRPW4PVSwF1I2rSZY25/nW88GfHD3cpcBFm90THQPTvfG0eQCWfT9GCYdBPe+p07DGimqnovg2nJewqAMVm3tVQDHWAWiWjkUGIuBorgnXJ0iPEEk6zLr8fpv92XzxSAijkGrcghM5yIRKl1TIGGA7SLAIdMNZdjYOphUY5vfMBbUgT2ujpBYAdCfHc9cgNyGKfxhkwpHLfumbXqmR3gGEd4E1Rr9E0dFmp+i9EznFdW3EIUhBPIAdnQDl7Ma2LibgFDZYvw5D9EYpFGgIJw1PYl3f9efkIe6XXLXN3y3sI8AC',
        dataToEncryptHash: 'ff3f3f2c9956b07d2b1acfb286c11aa4103763f250373076116696c5c3b33230',
        solanaAddress: '36nWszWtjg6t5qn1JSG5yk1CpLK8J8QfQPvE9aRV1gh3',
        suiAddress: '0xbabebaee091163e322f67bdeadda88f879f30b3bace277380b758cab5a0c0340',
    },
    //@ts-ignore //we're no longer using lit, these are the centralized orchestrators
    {
        ethAddress: '0xAf3D897A4B889B9807EAFc1805F84a07618eE855',
        solanaAddress: 'FA7vpBBaTxHuLVoyvsbeLzMjDzYfZfju73tJbif6Shn8',
        suiAddress: '0x48bd081cb7219622a97bfcdc1d632f9b8019cc6039e3f71dac2fc5cb1ce50fde',
    },
];
const DATIL_MAINNET_STAGING_ORCHESTRATORS = [
    //First is fee collector
    {
        hexTokenId: '0x851d6f495fabde01cfae20091edcbc3d23f752e81d43527af4c68c52bea46f91',
        tokenId: '60209615498448973033740783833547297483970240169033645919960513423105155428241',
        publicKey: '0x04bed79c975b616c7216a772054d370b8479f7fdbe096a2627bf306451ae6446cb308884174e9b7e0e2b40740fc148c8031fcfe70151e2b6dca01814372e38ed6b',
        // ethAddress: '0xcb1178A50a01147949c883432aee904Eb7788015',
        //replacing with the below address for fee collection that we have keys for
        ethAddress: '0x34dac76555Ab52fAB3Eb7071fB864Dbb8FA3752d',
        ciphertext: 'pCIxj/zz4Lg726HS8foO4qxqWxVYFnetwbg/VJHPL+YjicLWocZIVa87gBZWTLCwDTQ0QAxlWEQJCFTTigKEjjFRT7cZXqi6nHNqNTIrr/3lAVoq/0jRPW4PVSwF1I2rSZY25/nW88GfHD3cpcBFm90THQPTvfG0eQCWfT9GCYdBPe+p07DGimqnovg2nJewqAMVm3tVQDHWAWiWjkUGIuBorgnXJ0iPEEk6zLr8fpv92XzxSAijkGrcghM5yIRKl1TIGGA7SLAIdMNZdjYOphUY5vfMBbUgT2ujpBYAdCfHc9cgNyGKfxhkwpHLfumbXqmR3gGEd4E1Rr9E0dFmp+i9EznFdW3EIUhBPIAdnQDl7Ma2LibgFDZYvw5D9EYpFGgIJw1PYl3f9efkIe6XXLXN3y3sI8AC',
        dataToEncryptHash: 'ff3f3f2c9956b07d2b1acfb286c11aa4103763f250373076116696c5c3b33230',
        solanaAddress: '36nWszWtjg6t5qn1JSG5yk1CpLK8J8QfQPvE9aRV1gh3',
        suiAddress: '0xbabebaee091163e322f67bdeadda88f879f30b3bace277380b758cab5a0c0340',
    },
    //@ts-ignore
    {
        ethAddress: '0xAf3D897A4B889B9807EAFc1805F84a07618eE855',
        solanaAddress: 'FA7vpBBaTxHuLVoyvsbeLzMjDzYfZfju73tJbif6Shn8',
        suiAddress: '0x48bd081cb7219622a97bfcdc1d632f9b8019cc6039e3f71dac2fc5cb1ce50fde',
    },
    //@ts-ignore
    {
        ethAddress: '0x20518BE1a498B752d467516C5A3Ad4Ff697e96fC',
        solanaAddress: '7ekgVkTgWz66qALaAr4frXv1ymM24sEDBfqeMksVWbYW',
        suiAddress: '0x788e9345cd8436c04410e2468c4f11fc2dd810e824e3b9522478b5d9d85e9580',
    },
    //@ts-ignore
    {
        ethAddress: '0x362C85812f38Ad85Ad778bAdFb920D902E1c984F',
        solanaAddress: 'Goiquyrn7qyS7cn3YenfgJC8qDYp5TntoK4wAkkB6fe5',
        suiAddress: '0x61c7e250c6f0baeff18b7835a4dcaef44905141b6082521ec77764ca7aac2cfd',
    },
    //@ts-ignore
    {
        ethAddress: '0xa15801812370b8Ff1AB3863A59323672FF312C19',
        solanaAddress: '8Vh7mtXUwHt1iDY33X7obzfmv4LWzc2EbPgCfxWcyKnt',
        suiAddress: '0x819d7dca85977c662f52bbf012f032e59674ce1d9615c8a2599c26d42de0d5c1',
    },
    //@ts-ignore
    {
        ethAddress: '0xf355AC6D016303CD396A0b4663dCD0FC7c308f97',
        solanaAddress: '5eMg2RLB3PLuaP2HeqTagb6gWUsgjK9KaaYU2toBnmQq',
        suiAddress: '0x5190df9e8b3023980fc23a5035d478e79cdec6d91fbc75d3b68a3ad5cc2183c0',
    },
];
export const SUI_RPC_URL = process.env.SUI_RPC_URL;
export const ETHEREUM_RPC_URL = process.env.ETHEREUM_RPC_URL;
export const AVALANCHE_RPC_URL = process.env.AVALANCHE_RPC_URL;
export const SOLANA_RPC_URL = process.env.SOLANA_RPC_URL;
export const BASE_RPC_URL = process.env.BASE_RPC_URL;
export const ARBITRUM_RPC_URL = process.env.ARBITRUM_RPC_URL;
export const OPTIMISM_RPC_URL = process.env.OPTIMISM_RPC_URL;
export const BSC_RPC_URL = process.env.BSC_RPC_URL;
export const FANTOM_RPC_URL = process.env.FANTOM_RPC_URL;
export const POLYGON_RPC_URL = process.env.POLYGON_RPC_URL;
export const BLAST_RPC_URL = process.env.BLAST_RPC_URL;
export const JITO_RPC_URL = process.env.JITO_RPC_URL;
export const JITO_RPC_URL_2 = process.env.JITO_RPC_URL_2;
export const JITO_RPC_URL_3 = process.env.JITO_RPC_URL_3;
export const JUPITER_API_ENDPOINT = process.env.JUPITER_SWAP_API;
export const JITO_TRANSACTIONS_URL = `${JITO_RPC_URL}/api/v1/transactions`;
export const TENDERLY_KEY = process.env.TENDERLY_KEY;
export const TENDERLY_PROJECT = process.env.TENDERLY_PROJECT;
export const TENDERLY_USER = process.env.TENDERLY_USER;
export const TENDERLY_URL = `https://api.tenderly.co/api/v1/account/${TENDERLY_USER}/project/${TENDERLY_PROJECT}/simulate-bundle`;
export const FLASHBOTS_BUNDLE_RELAY = process.env.FLASHBOTS_BUNDLE_RELAY;
export const DEFINED_API_KEY = process.env.DEFINED_API_KEY;
export const RPCS = {
    1: process.env.ETHEREUM_RPC_URL,
    56: process.env.BSC_RPC_URL,
    137: process.env.POLYGON_RPC_URL,
    42161: process.env.ARBITRUM_RPC_URL,
    43114: process.env.AVALANCHE_RPC_URL,
    8453: process.env.BASE_RPC_URL,
    250: process.env.FANTOM_RPC_URL,
    10: process.env.OPTIMISM_RPC_URL,
    814572: process.env.BLAST_RPC_URL,
    1399811149: process.env.SOLANA_RPC_URL,
    101: process.env.SUI_RPC_URL,
    jito: process.env.JITO_QUICKNODE_URL,
};
export const LIT_ACTION_KEYS = {
    ETHEREUM_RPC_URL,
    AVALANCHE_RPC_URL,
    SOLANA_RPC_URL,
    BASE_RPC_URL,
    ARBITRUM_RPC_URL,
    OPTIMISM_RPC_URL,
    BSC_RPC_URL,
    FANTOM_RPC_URL,
    POLYGON_RPC_URL,
    BLAST_RPC_URL,
    JITO_RPC_URL,
    JUPITER_API_ENDPOINT,
    JITO_TRANSACTIONS_URL,
    TENDERLY_KEY,
    TENDERLY_PROJECT,
    TENDERLY_USER,
    TENDERLY_URL,
    RPCS,
    ENVIRONMENT,
    FLASHBOTS_BUNDLE_RELAY,
};
export const FEE_COLLECTION_ADDRESS = (_b = (_a = ORCHESTRATORS({ excludeFeeCollector: false })) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.ethAddress;
export const SOLANA_FEE_COLLECTION_ADDRESS = (_d = (_c = ORCHESTRATORS({ excludeFeeCollector: false })) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.solanaAddress;
export const FEE_COLLECTION_ORCHESTRATOR = (_e = ORCHESTRATORS({ excludeFeeCollector: false })) === null || _e === void 0 ? void 0 : _e[0];
export const SUI_FEE_COLLECTION_ADDRESS = process.env.SUI_FEE_COLLECTION_ADDRESS;
//does not include fee collector
export const RANDOM_ORCHESTRATOR = () => {
    var _a, _b;
    return (_a = ORCHESTRATORS({})) === null || _a === void 0 ? void 0 : _a[Math.floor(Math.random() * ((_b = ORCHESTRATORS({})) === null || _b === void 0 ? void 0 : _b.length))];
};
export const FEE_BPS = 100; // 100 basis points
export const SINGLE_CHAIN_FEE_BPS_TIERS = new Map([
    [50000, 100], // 50k or above: 20bps
    [10000, 100], // 10k or above: 30bps
    [0, 100], // Less than 10k: 50bps
]);
export const MULTI_CHAIN_FEE_BPS_TIERS = new Map([
    [50000, 100], // 50k or above: 30bps
    [10000, 100], // 10k or above: 40bps
    [0, 100], // Less than 10k: 60bps
]);
